// extracted by mini-css-extract-plugin
export default {"list":"_5fOXIYzO","left":"_1pt0I5jl","right":"_2hLWEvtb"};